<template>
    <div class="" :class="getClasses()">
        <slot></slot>
    </div>
</template>

<style scoped>
.scrollable.row {
  overflow-x: auto;
  white-space: nowrap;
}
.scrollable.row > [class^=".col-"] {
  display: inline-block;
  float: none;
}
</style>

<script>
export default {
    name: "GridRow",
    props: {
        gap: {
            type: [Number, String],
            required: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            classes: {},
        }
    },
    methods: {
        getClasses() {
            this.classes['scrollable'] = this.scrollable;
            this.classes['row'] = true;
            this.classes['gap-' + this.gap] = (this.gap && Number.parseInt(this.gap, 10) != -1);
            return this.classes
        },
    },
}
</script>